export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#111111] text-[#F2EFE9]/80 border-t border-[#333333] px-4 md:px-8 lg:px-12 py-10">
      <div className="grid grid-cols-12 gap-6 items-end">
        <div className="col-span-12 md:col-span-6">
          <div className="font-anton uppercase text-5xl md:text-6xl text-[#F2EFE9]">JP Kuster</div>
          <div className="font-cormorant italic text-lg mt-1">
            Brand &amp; marketing, rooted in culture — built to scale.
          </div>
        </div>

        <div className="col-span-6 md:col-span-3 font-mono-s text-[10px] tracking-[0.25em] uppercase">
          <div className="text-[#F2EFE9]/50 mb-2">Social</div>
          <ul className="space-y-1">
            <li>
              <a className="link-underline" href="https://www.linkedin.com/in/jpkuster" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin">
                LinkedIn →
              </a>
            </li>
            <li>
              <a className="link-underline" href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram">
                Instagram →
              </a>
            </li>
            <li>
              <a className="link-underline" href="mailto:hello@jpkuster.com" data-testid="footer-email">
                hello@jpkuster.com →
              </a>
            </li>
          </ul>
        </div>

        <div className="col-span-6 md:col-span-3 font-mono-s text-[10px] tracking-[0.25em] uppercase text-right md:text-left">
          <div className="text-[#F2EFE9]/50 mb-2">Location</div>
          <div>Chicago, IL</div>
          <div>Los Angeles, CA</div>
          <div className="mt-2">⌖ 41.87° N · 87.62° W</div>
        </div>
      </div>

      <div className="font-mono-s text-[10px] tracking-[0.3em] uppercase text-[#F2EFE9]/40 mt-10 pt-6 border-t border-[#333333] flex flex-col md:flex-row gap-3 justify-between">
        <span>© {new Date().getFullYear()} John &quot;JP&quot; Kuster — All rights reserved.</span>
        <span>Site designed & built with intent.</span>
      </div>
    </footer>
  );
}
